import {ChangeDetectorRef, Component, ElementRef, Inject, Input, ViewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Merchant, StaffControllerService, StaffProfileControllerService} from "../../@services/gen";

@Component({
  selector: 'app-pos-discount-dialog',
  templateUrl: './auth-role-check-dialog.component.html',
  styleUrls: ['./auth-role-check-dialog.component.scss'],
})
export class AuthRoleCheckDialogComponent {
  @ViewChild('staffNoInput') staffNoInput!: ElementRef;

  @Input()
  staffNo: string;
  merchant: Merchant;
  remark: string;
  isRequireRemark: boolean;

  @Input()
  errorMessage: string;

  fieldType: string = 'password';


  constructor(private dialogRef: MatDialogRef<AuthRoleCheckDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any,
              private staffProfileControllerService: StaffProfileControllerService, private cdr: ChangeDetectorRef) {
    this.staffNo = data.staffNo;
    this.remark = data.remark;
    this.merchant = data.merchant;
    this.errorMessage = data.errorMessage;
    this.isRequireRemark = data.isRequireRemark;

  }

  submit() {
    const command = {
      staffNo: this.staffNo,
      remark: this.remark,
      merchantId: this.merchant.id
    }

    this.staffProfileControllerService.getStaffByStaffNoQueryPost(command).subscribe((res) => {
      this.dialogRef.close({
        process: 'submit',
        staffNo: this.staffNo,
        remark: this.remark,
        staff: res
      });
    });

  }

  onCancel() {
    // Handle the cancel action
    this.dialogRef.close({process: 'cancel'});
  }

  toggleFieldVisibility(): void {
    this.fieldType = this.fieldType === 'password' ? 'text' : 'password';

    // Set focus back to the input field
    setTimeout(() => {
      this.staffNoInput.nativeElement.focus();
    }, 0); // Timeout ensures focus after the DOM update
  }
}
